module.exports = __webpack_public_path__ + "c8f77d6035354cf4cbf9d9c08539b7f8.svg";